export default __webpack_public_path__ + "static/media/location.3a783c59.mp3";